import { ButtonHTMLAttributes } from "react";
import { Botao } from "./styles"
import { IButtonProps } from "../../@interfaces";

const BotaoFiltrar: React.FC<IButtonProps> = ({ loading, ...rest }) => {
  return (
    <Botao {...rest}>
      {loading ? "• • •" : "Buscar"}
    </Botao>
  )
}

export default BotaoFiltrar;